<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sigilnotintoc">CONTENTS</h2>
<ul class="TOC">
<li class="calibre6"><a href="#/Text/Section0005.htm#CHAPTER_I"><span class="smcap">From Mobilisation to the East</span></a></li>
<li class="calibre6"><a href="#/Text/Section0006.htm#CHAPTER_II"><span class="smcap">Gallipoli—to 11th July, 1915</span></a></li>
<li class="calibre6"><a href="#/Text/Section0007.htm#CHAPTER_III"><span class="smcap">Gallipoli</span> (<i class="calibre7">contd.</i>)—<span class="smcap">Operations 12th-18th July, 1915</span></a></li>
<li class="calibre6"><a href="#/Text/Section0008.htm#CHAPTER_IV"><span class="smcap">Gallipoli</span> (<i class="calibre7">contd.</i>)</a></li>
<li class="calibre6"><a href="#/Text/Section0009.htm#CHAPTER_V"><span class="smcap">Gallipoli</span> (<i class="calibre7">concluded</i>)</a></li>
<li class="calibre6"><a href="#/Text/Section0010.htm#CHAPTER_VI"><span class="smcap">Mudros, Cairo, Suez Canal and Hill 70 Line</span></a></li>
<li class="calibre6"><a href="#/Text/Section0011.htm#CHAPTER_VII"><span class="smcap">The Sinai Desert, Mahamdiya, Romani, Katia</span></a></li>
<li class="calibre6"><a href="#/Text/Section0012.htm#CHAPTER_VIII"><span class="smcap">Across the Sinai Desert to El Arish</span></a></li>
<li class="calibre6"><a href="#/Text/Section0013.htm#CHAPTER_IX"><span class="smcap">El Arish and First Battle of Gaza</span></a></li>
<li class="calibre6"><a href="#/Text/Section0014.htm#CHAPTER_X"><span class="smcap">Second Battle of Gaza</span></a></li>
<li class="calibre6"><a href="#/Text/Section0015.htm#CHAPTER_XI"><span class="smcap">Gaza, 1st May To 7th November, 1917</span></a></li>
<li class="calibre6"><a href="#/Text/Section0016.htm#CHAPTER_XII"><span class="smcap">Advance beyond Gaza. Wadi Hesi, Sausage Ridge,<br class="calibre1"/>
    Esdud, Kubeibeh, Nebi Samwil, Tahta</span></a></li>
<li class="calibre6"><a href="#/Text/Section0017.htm#CHAPTER_XIII"><span class="smcap">From Tahta to the Auja</span></a></li>
<li class="calibre6"><a href="#/Text/Section0018.htm#CHAPTER_XIV"><span class="smcap">Last Days in Palestine. North of Jaffa</span></a></li>
<li class="calibre6"><a href="#/Text/Section0019.htm#CHAPTER_XV"><span class="smcap">France</span></a></li>
</ul>
<h3 class="sigilnotintoc sigil_not_in_toc" id="pgepubid00007"><a class="calibre8" href="#/Text/Section0020.htm#APPENDICES">APPENDICES</a></h3>
<ul class="TOC">
<li class="calibre6"><a href="#/Text/Section0020.htm#APPENDIX_I"><span class="smcap">List of Officers, Senior N.C.O.'s, etc., who embarked in<br class="calibre1"/>
    May, 1915</span></a></li>
<li class="calibre6"><a href="#/Text/Section0021.htm#APPENDIX_II"><span class="smcap">Roll of Officers, Warrant Officers, Non-Commissioned<br class="calibre1"/>
    Officers and Men who died on Service</span></a></li>
<li class="calibre6"><a href="#/Text/Section0022.htm#APPENDIX_III"><span class="smcap">Honours and Awards</span></a></li>
<li class="calibre6"><a href="#/Text/Section0023.htm#APPENDIX_IV"><span class="smcap">Turkish Orders for Advance on Romani</span></a></li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?75099c96